/**
 * 一般
 */
export const GENERAL = 0;

/**
 * 管理者
 */
export const ADMIN = 1;

/**
 * 特権管理者
 */
export const SUPER_ADMIN = 2;
